import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ordinalize } from '../../../../../numberUtils';
import { interviewAvailabilityShape } from '../../../../../dateUtils';
import { deleteRequest } from '../../../../../requestUtils';
import { analyticsTrack } from '../../../../../analyticsUtils';
import InterviewAttendees from '../../../../common/InterviewSubComponents/InterviewAttendees';
import InterviewTimeRange from '../../../../common/InterviewSubComponents/InterviewTimeRange';
import InterviewTimezone from '../../../../common/InterviewSubComponents/InterviewTimezone';
import InterviewMeetingDetails from '../../../../common/InterviewSubComponents/InterviewMeetingDetails';
import InterviewActions from '../../../../common/InterviewSubComponents/InterviewActions';
function UpcomingInterviewCard(_ref) {
  var interview = _ref.interview,
    csrfToken = _ref.csrfToken,
    onCancel = _ref.onCancel,
    onSubmitMeetingDetails = _ref.onSubmitMeetingDetails,
    canEdit = _ref.canEdit,
    canCancel = _ref.canCancel,
    consultantView = _ref.consultantView,
    isRep = _ref.isRep,
    possibleInterviewers = _ref.possibleInterviewers,
    invitableRoles = _ref.invitableRoles,
    editModalRef = _ref.editModalRef,
    resheduleModalRef = _ref.resheduleModalRef,
    repOrOwner = _ref.repOrOwner,
    availableInterviewSlotUrl = _ref.availableInterviewSlotUrl;
  var handleCancelInterview = function handleCancelInterview() {
    deleteRequest(interview.cancel_interview_path, csrfToken).then(function (response) {
      analyticsTrack('Interview cancelled; type: upcoming', {
        location: 'Proposal Page View'
      });
      onCancel(interview.id, response, 'upcoming');
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "interview-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "interview-info-header upcoming"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "medium-weight mb-8"
  }, ordinalize(interview.round_number), ' ', "round -", ' ', interview.slot_duration_minutes, ' ', "min call"), /*#__PURE__*/React.createElement(InterviewTimeRange, {
    interviewTime: interview.accepted_time,
    containerClassName: "normal-weight body-text-2 mb-4",
    opts: {
      timeZone: 'UTC',
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "normal-weight body-text-2 muted-gray-text"
  }, /*#__PURE__*/React.createElement(InterviewTimezone, {
    timezoneStr: interview.timezone,
    dateStr: interview.accepted_time.date
  }))), /*#__PURE__*/React.createElement(InterviewAttendees, {
    attendees: interview.attendees,
    consultantView: consultantView
  }), /*#__PURE__*/React.createElement("hr", {
    className: "half-width"
  }), /*#__PURE__*/React.createElement(InterviewMeetingDetails, {
    meetingDetails: interview.meeting_details,
    csrfToken: csrfToken,
    isRep: isRep,
    editInterviewPath: interview.edit_interview_path,
    onSubmit: onSubmitMeetingDetails
  })), canCancel && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(InterviewActions, {
    interview: interview,
    interviewType: "upcoming",
    editInterviewPath: interview.edit_interview_path,
    csrfToken: csrfToken,
    possibleInterviewers: possibleInterviewers,
    invitableRoles: invitableRoles,
    editModalRef: editModalRef,
    resheduleModalRef: resheduleModalRef,
    canEdit: canEdit,
    canCancel: canCancel,
    location: "Proposal Page",
    onCancel: function onCancel() {
      return handleCancelInterview();
    },
    repOrOwner: repOrOwner,
    availableInterviewSlotUrl: availableInterviewSlotUrl,
    interviewReschedule: true
  })));
}
UpcomingInterviewCard.propTypes = {
  interview: PropTypes.shape({
    id: PropTypes.number.isRequired,
    round_number: PropTypes.number.isRequired,
    accepted_time: interviewAvailabilityShape,
    timezone: PropTypes.string.isRequired,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string
    }).isRequired,
    cancel_interview_path: PropTypes.string.isRequired
  }).isRequired,
  csrfToken: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmitMeetingDetails: PropTypes.func.isRequired,
  canCancel: PropTypes.bool,
  canEdit: PropTypes.bool,
  consultantView: PropTypes.bool,
  isRep: PropTypes.bool,
  possibleInterviewers: PropTypes.shape({}).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  editModalRef: PropTypes.func.isRequired,
  resheduleModalRef: PropTypes.func.isRequired,
  repOrOwner: PropTypes.bool
};
UpcomingInterviewCard.defaultProps = {
  canCancel: false,
  canEdit: false,
  consultantView: false,
  isRep: false,
  repOrOwner: false
};
export default UpcomingInterviewCard;